/**
 * Architectural double-rule gold frame with ornamental corner flourishes.
 * Designed to wrap around the hero content so the page itself reads as the
 * logo's frame extended — the entire title page becomes the seal, not just
 * the centered mark.
 *
 * Absolutely positioned. The parent must be `position: relative` and is
 * expected to provide its own dark background.
 */
export default function HeroFrame() {
  return (
    <div className="pointer-events-none absolute inset-0 z-10" aria-hidden="true">
      {/* Outer rule */}
      <div className="absolute inset-4 md:inset-8 lg:inset-10 border border-gold/55" />
      {/* Inner rule (thin, dimmer — creates double-rule depth) */}
      <div className="absolute inset-6 md:inset-12 lg:inset-14 border border-gold/15" />

      {/* Corner flourishes — SVG ornaments at each corner */}
      <Flourish className="absolute top-3 left-3 md:top-7 md:left-7 lg:top-9 lg:left-9" rotate={0} />
      <Flourish className="absolute top-3 right-3 md:top-7 md:right-7 lg:top-9 lg:right-9" rotate={90} />
      <Flourish className="absolute bottom-3 right-3 md:bottom-7 md:right-7 lg:bottom-9 lg:right-9" rotate={180} />
      <Flourish className="absolute bottom-3 left-3 md:bottom-7 md:left-7 lg:bottom-9 lg:left-9" rotate={270} />
    </div>
  );
}

function Flourish({ className = "", rotate = 0 }) {
  return (
    <svg
      viewBox="0 0 48 48"
      className={`w-9 h-9 md:w-12 md:h-12 text-gold ${className}`}
      style={{ transform: `rotate(${rotate}deg)` }}
      fill="none"
      stroke="currentColor"
      strokeWidth="1"
      strokeLinecap="round"
    >
      {/* Inner small arc */}
      <path d="M4 4 C 18 6, 22 12, 24 24" opacity="0.9" />
      {/* Outer spiral curl */}
      <path d="M4 4 C 14 2, 26 6, 28 18 C 28 26, 22 30, 16 28 C 12 26, 12 20, 16 18 C 19 17, 22 19, 22 22" opacity="0.8" />
      {/* Small leaf accent */}
      <path d="M30 12 Q 36 14, 34 22" opacity="0.7" />
      {/* Anchor dot */}
      <circle cx="4" cy="4" r="0.9" fill="currentColor" stroke="none" />
    </svg>
  );
}
